import React, { useState } from "react"
import { Animated, ViewProps } from "react-native"
import { useTheme } from "styled-rn"

import { Loading } from "./svgAnimations/Loading"

export function useFadeIn() {
  const startAnimation = useState(new Animated.Value(0))[0]
  const onStartOpacity = startAnimation.interpolate({ inputRange: [0, 1], outputRange: [0, 1] })

  const mounted = React.useRef(false)
  if (!mounted.current) {
    mounted.current = true
    Animated.timing(startAnimation, {
      isInteraction: false,
      toValue: 1,
      useNativeDriver: true,
      duration: 250,
      delay: 125,
    }).start()
  }

  return { onStartOpacity }
}

export function PulsingLoader(props: ViewProps & { width?: number; loaderColor?: string }) {
  const { onStartOpacity } = useFadeIn()
  const theme = useTheme()
  const width = props.width || 120
  return (
    <Animated.View
      id="PulsingLoader"
      pointerEvents={"none"}
      style={{
        width: "100%",
        height: "100%",
        position: "absolute",
        justifyContent: "center",
        alignItems: "center",
        opacity: onStartOpacity,
      }}
    >
      <Animated.View
        style={{
          opacity: 0.33,
        }}
      >
        <Loading fill={props.loaderColor || theme.fg} width={width} />
      </Animated.View>
    </Animated.View>
  )
}
